export default "__VITE_ASSET__c0365402__"